import React from "react";
import TestimonialAreaThreeItem from "./TestimonialAreaThreeItem";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSwiperArrows } from "../../lib/hooks/useSwiperArrows";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const testimonials = [
  {
    img: "/img/images/testimonial_avatar01.png",
    name: "Sanne de Vries",
    role: "Particuliere klant",
    text: "Mijn oude fauteuils zijn volledig vernieuwd en zien er prachtig uit! De stof en het vakmanschap zijn van topkwaliteit.",
  },
  {
    img: "/img/images/testimonial_avatar02.png",
    name: "Mehmet Kaya",
    role: "Restaurant eigenaar",
    text: "Onze stoelen en banken zijn perfect herstoffeerd. Klanten reageren super positief over het nieuwe interieur.",
  },
  {
    img: "/img/images/testimonial_avatar03.png",
    name: "Emma Jansen",
    role: "Interieurarchitect",
    text: "Zeer professioneel! Samen projecten gedaan waarbij ze perfect konden meedenken in maatwerk en esthetiek.",
  },
  {
    img: "/img/images/testimonial_avatar04.png",
    name: "Lars Bakker",
    role: "Kantoormanager",
    text: "Onze vergaderruimtes zijn compleet opnieuw ingericht en de stoffering is duurzaam én stijlvol.",
  },
  {
    img: "/img/images/testimonial_avatar05.png",
    name: "Aïsha el Amrani",
    role: "Particuliere klant",
    text: "Mijn vintage bank is prachtig hersteld! De kleuren en afwerking zijn echt beter dan ik had durven dromen.",
  },
  {
    img: "/img/images/testimonial_avatar06.png",
    name: "Jan-Willem de Groot",
    role: "Hotel eigenaar",
    text: "Voor ons hotel is de lounge opnieuw gestoffeerd. Zeer hoge kwaliteit en alles netjes volgens afspraak.",
  },
];

const swiper_settings = {
  spaceBetween: 30,
  slidesPerView: 1.5,
  loop: true,
  autoplay: { delay: 5000, disableOnInteraction: true },
  breakpoints: {
    1500: { slidesPerView: 3 },
    1200: { slidesPerView: 3 },
    992: { slidesPerView: 2 },
    768: { slidesPerView: 1.2 }, 
    576: { slidesPerView: 1 },
    0: { slidesPerView: 1 },
  },
  
};

const TestimonialAreaFour = () => {
  const { sliderRef, toNext, toPrev } = useSwiperArrows();

  return (
    <section className="testimonial-area-three testimonial-area-four">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8">
            <div className="section-title title-style-two mb-45">
              <span className="sub-title">Ervaringen</span>
              <h2 className="title">Wat Klanten Zeggen over Vernu Stoffering</h2>
            </div>
          </div>
          <div className="col-md-4">
            <div className="testimonial-nav">
              <button className="swiper-button-prev" onClick={toPrev}></button>
              <button className="swiper-button-next" onClick={toNext}></button>
            </div>
          </div>
        </div>

        <div className="swiper-container testimonial-active-three">
          <Swiper
            {...swiper_settings}
            onBeforeInit={(swiper) => {
              sliderRef.current = swiper;
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <TestimonialAreaThreeItem item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default TestimonialAreaFour;
